var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogisticsBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 178,
    viewBox: "0 0 157 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_178)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.941 165.025L76.2343 178L76.2343 15.1565L157 6.06946L156.941 165.025Z",
    fill: "url(#paint0_linear_107_178)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 166.756L76.2343 178L76.2343 15.1566L0 9.23462L0 166.756Z",
    fill: "url(#paint1_linear_107_178)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157 6.0695L76.2343 15.1565L0 9.23458L66.3664 0L157 6.0695Z",
    fill: "#FAE7CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.546 2.49122L38.4666 12.225L37.6689 12.3431L36.002 12.2816L37.1034 12.1193L102.524 2.42236L103.546 2.49122Z",
    fill: "#CA9151"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2343 15.1565C50.8072 13.3809 25.3958 11.4062 0 9.23218C25.4271 11.0061 50.8385 12.9809 76.2343 15.1565Z",
    fill: "#CA9151"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1361 172.971V164.789C42.0137 164.794 41.891 164.785 41.7707 164.762C40.615 164.592 40.7681 163.852 39.6099 163.677C38.4517 163.503 38.2912 164.243 37.1404 164.068C35.9897 163.894 36.1378 163.153 34.9747 162.984C34.7774 162.948 34.5758 162.944 34.3772 162.971C33.7104 163.07 33.419 163.51 32.4979 163.372C31.3373 163.203 31.4953 162.46 30.3372 162.285C29.179 162.111 29.0185 162.851 27.8677 162.676C27.5707 162.643 27.2879 162.531 27.0478 162.354V170.743L42.1361 172.971Z",
    fill: "#C1A477"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5937 11.3693L27.3664 17.7634C27.3664 17.7634 28.6011 17.0846 29.779 17.1584C30.9569 17.2322 30.8878 17.9773 32.0682 18.0486C33.1844 18.115 33.3029 17.4412 34.3154 17.4363C34.3673 17.4363 34.4241 17.4363 34.4809 17.4363C35.6538 17.5076 35.5922 18.2577 36.7676 18.3266C37.9431 18.3954 38.0024 17.6478 39.1803 17.7216C40.3582 17.7954 40.2939 18.5405 41.4669 18.6118C41.6759 18.628 41.8862 18.6097 42.0892 18.5577V12.5177L27.5937 11.3693Z",
    fill: "#C1A477"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5937 11.3693L42.0843 12.5227L55.128 10.5036C54.8193 10.4766 54.8315 10.2798 54.5204 10.2577C54.2092 10.2356 51.3102 9.78797 50.9867 9.76584C50.6632 9.7437 49.6335 9.83715 49.31 9.81993C49.2754 9.81993 48.9272 9.71421 48.8926 9.71913C48.663 9.74126 46.5343 8.91738 46.2453 8.89771C46.1342 8.89771 44.7514 9.10427 44.6946 9.06492L27.5937 11.3693Z",
    fill: "#C1A477"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1357 4.1635C97.1505 4.1635 97.1209 4.1389 96.9085 4.13152C96.2714 4.11185 95.4416 4.17336 94.7921 4.15614C94.1427 4.13893 94.923 4.07005 94.1945 4.04792C93.5945 4.02578 92.9771 4.07004 92.3795 4.0725C92.2264 4.0725 92.0733 4.0725 91.9152 4.0725C91.1102 4.05037 91.8214 3.97413 90.9522 3.94708C90.0434 3.91757 89.3989 3.99875 88.4827 3.97416C87.5196 3.94464 88.0901 3.85365 87.0331 3.82168C86.9097 3.82168 86.7863 3.82168 86.6751 3.82168L96.9455 2.05591L106.352 2.68793L97.1357 4.1635Z",
    fill: "#C1A477"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6585 170.443L45.0254 169.548L45.1267 160.035L52.73 160.724L52.6585 170.443ZM45.4354 169.078L52.2411 169.867L52.3078 161.208L45.5243 160.583L45.4354 169.078Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7411 171.51L53.7253 170.568L53.7944 160.819L61.7781 161.542L61.7411 171.51ZM54.1525 170.088L61.3139 170.917L61.3485 162.039L54.2241 161.383L54.1525 170.088Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2682 172.629L62.8401 171.645L62.8745 161.648L71.2707 162.408L71.2682 172.629ZM63.2895 171.153L70.804 172.026V162.927L63.3142 162.236L63.2895 171.153Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9923 164.725C55.9923 165.804 56.6343 166.766 57.4739 166.987V168.738L57.0418 168.689V169.223L56.3972 169.152V169.683L58.995 169.98V169.444L58.3407 169.37V168.834L57.9061 168.785V167.032C58.763 166.992 59.4321 166.163 59.4371 165.064V162.927L55.9799 162.6L55.9923 164.725Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0747 170.017V170.561L69.994 171.237V170.684L64.0747 170.017Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2008 169.734L65.6527 169.786L66.1046 169.835L66.112 165.608L65.6601 165.563L65.2107 165.517L65.2008 169.734Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9246 170.039L68.3814 170.091L68.8408 170.143L68.8457 165.883L68.3864 165.836L67.9295 165.79L67.9246 170.039Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6651 163.254L64.539 165.044L66.7936 165.268L65.6651 163.254Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3888 163.51L67.248 165.313L69.5347 165.539L68.3888 163.51Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8753 161.801C47.1244 161.633 46.107 162.807 46.0922 164.371L48.8481 164.653L48.821 167.774C48.821 168.062 48.6309 168.266 48.4037 168.249C48.28 168.217 48.1714 168.143 48.0973 168.04C48.0232 167.936 47.9883 167.81 47.9987 167.683V167.423L47.5887 167.378V167.639C47.5887 168.21 47.9468 168.719 48.4011 168.77C48.8555 168.822 49.2284 168.396 49.2334 167.821L49.2605 164.695L51.651 164.941C51.6633 163.352 50.6434 161.968 48.8753 161.801Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_107_178",
    x1: 157,
    y1: 92.0359,
    x2: 76.2343,
    y2: 92.0359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF8E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6AE88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_107_178",
    x1: 76.2343,
    y1: 93.6173,
    x2: 0,
    y2: 93.6173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6EBD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3C9A0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 157,
    height: 178,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogisticsBox);
export default __webpack_public_path__ + "static/media/LogisticsBox.c72b738983e8a1736e14dab5f25613f1.svg";
export { ForwardRef as ReactComponent };